import React, { useState, useEffect, useRef } from "react";
import { Link, useNavigate } from "react-router-dom";
import axios from "axios";
import { Offcanvas } from "bootstrap";
import "@fortawesome/fontawesome-free/css/all.min.css";

const Navbar = () => {
  const [categories, setCategories] = useState([]);

  const navigate = useNavigate();
  const offcanvasRef = useRef(null);
  const offcanvasInstance = useRef(null);

  /* ================== CATEGORÍAS ================== */
  useEffect(() => {
    axios
      .get(
        "https://ryc-soluciones-nicaragua.com/api/index.php?getAllCategory=true"
      )
      .then((res) =>
        setCategories(
          res.data
            .filter(
              (c) =>
                c.category !== "Restaurante" &&
                c.category !== "SkinCare" &&
                c.category !== "Jabones Organicos"
            )
            .map((c) => ({ id: c.id, nombre: c.category }))
        )
      )
      .catch(() => setCategories([]));
  }, []);

  /* ================== OFFCANVAS ================== */
  useEffect(() => {
    if (offcanvasRef.current) {
      offcanvasInstance.current = new Offcanvas(offcanvasRef.current);
    }
  }, []);

  /* ================== CATEGORY CLICK ================== */
  const handleCategoryClick = (path) => {
    navigate(path);
    offcanvasInstance.current?.hide();
  };

  const openCategories = () => offcanvasInstance.current?.show();

  return (
    <nav className="ryc-nav">
      <style>{css}</style>

      <div className="ryc-bar">
        {/* Logo */}
        <Link to="/" className="ryc-logo" aria-label="Ir al inicio">
          <img
            src="https://ryc-soluciones-nicaragua.com/imagenes/cropped-cropped-logo-editable-192x192.png"
            alt="RyC"
          />
        </Link>

        {/* Categorías */}
        <button type="button" className="ryc-pill" onClick={openCategories}>
          <i className="fa-solid fa-bars"></i>
          <span className="d-none d-lg-inline">Todas las categorías</span>
          <span className="d-lg-none">Categorías</span>
        </button>

        {/* Accesos rápidos (móvil: segunda fila / escritorio: misma fila) */}
        <div className="ryc-links">
          {/* <Link to="/productos/Liquidacion" className="btn btn-danger btn-sm">
            <i className="fa-solid fa-fire"></i> Liquidación
          </Link>
          <Link to="/productos/Novedades" className="btn btn-warning btn-sm">
            <i className="fa-solid fa-star"></i> Novedades
          </Link>
          <button
            type="button"
            className="btn btn-primary btn-sm ryc-contact-mobile"
            data-bs-toggle="modal"
            data-bs-target="#contactModal"
          >
            <i className="fa-solid fa-location-dot"></i> Contáctanos
          </button> */}
        </div>

        {/* Contacto (solo escritorio, a la derecha) */}
        {/* <button
          type="button"
          className="btn btn-primary btn-sm ryc-contact-desktop"
          data-bs-toggle="modal"
          data-bs-target="#contactModal"
        >
          <i className="fa-solid fa-location-dot"></i> Contáctanos
        </button> */}
      </div>

      {/* ===== OFFCANVAS ===== */}
      <div
        ref={offcanvasRef}
        className="offcanvas offcanvas-start"
        tabIndex="-1"
        aria-labelledby="rycCategoriasTitle"
      >
        <div className="ryc-offcanvas-header">
          <h5 id="rycCategoriasTitle">Categorías</h5>
          <button
            type="button"
            className="btn-close btn-close-white"
            data-bs-dismiss="offcanvas"
            aria-label="Cerrar"
          ></button>
        </div>

        <div className="offcanvas-body p-0">
          <ul className="ryc-cat-list">
            {categories
              .filter((c) => c.nombre.toLowerCase() !== "liquidacion")
              .map((c) => (
                <li key={c.id}>
                  <button
                    type="button"
                    onClick={() =>
                      handleCategoryClick(
                        `/productos/${c.nombre.replaceAll(" ", "-")}`
                      )
                    }
                  >
                    {c.nombre}
                    <i className="fa-solid fa-chevron-right"></i>
                  </button>
                </li>
              ))}
          </ul>
        </div>
      </div>
    </nav>
  );
};

/* ================== ESTILOS ================== */
const css = `
.ryc-nav {
  position: sticky;
  top: 0;
  z-index: 1050;
  box-shadow: 0 2px 8px rgba(0, 0, 0, 0.25);
}

/* ---------- Móvil (por defecto) ---------- */
.ryc-bar {
  display: flex;
  flex-wrap: wrap;
  align-items: center;
  background: #00377b;
}

/* Logo: pestaña blanca pegada arriba-izquierda con esquina curva */
.ryc-logo {
  display: flex;
  align-items: center;
  background: #fff;
  padding: 8px 18px 8px 14px;
  border-bottom-right-radius: 32px;
  margin-right: auto;
}
.ryc-logo img { width: 50px; height: 50px; display: block; }

.ryc-pill {
  background: #003366;
  border: 1px solid rgba(255, 255, 255, 0.25);
  border-radius: 60px;
  padding: 8px 16px;
  margin-right: 12px;
  color: #fff;
  font-size: 0.9rem;
  display: inline-flex;
  align-items: center;
  gap: 8px;
  cursor: pointer;
}
.ryc-pill:hover { background: #004080; }

/* Segunda fila con scroll horizontal si no cabe */
.ryc-links {
  order: 3;
  flex: 1 1 100%;
  display: flex;
  align-items: center;
  gap: 8px;
  padding: 8px 12px;
  background: #002b5c;
  overflow-x: auto;
  scrollbar-width: none;
}
.ryc-links::-webkit-scrollbar { display: none; }
.ryc-links .btn { white-space: nowrap; flex: 0 0 auto; }

.ryc-contact-desktop { display: none; }

/* ---------- Offcanvas ---------- */
.ryc-offcanvas-header {
  background: #00377b;
  color: #fff;
  border-radius: 40px;
  padding: 0.6rem 1.1rem;
  margin: 12px;
  display: flex;
  align-items: center;
  justify-content: space-between;
}
.ryc-offcanvas-header h5 { margin: 0; }

.ryc-cat-list { list-style: none; margin: 0; padding: 0; }
.ryc-cat-list li { border-bottom: 1px solid #eef1f6; }
.ryc-cat-list button {
  width: 100%;
  display: flex;
  align-items: center;
  justify-content: space-between;
  text-align: left;
  background: #fff;
  border: none;
  padding: 12px 20px;
  color: #333;
}
.ryc-cat-list button i { font-size: 0.7rem; color: #9aa7bd; }
.ryc-cat-list button:hover { background: #f0f4fa; color: #00377b; }

/* ---------- Escritorio: todo en una sola fila ---------- */
@media (min-width: 992px) {
  .ryc-bar {
    flex-wrap: nowrap;
    gap: 14px;
    padding: 8px max(16px, calc((100% - 1320px) / 2));
  }

  .ryc-logo {
    border-radius: 50%;
    padding: 4px;
    margin-right: 6px;
  }
  .ryc-logo img { width: 60px; height: 60px; }

  .ryc-pill { margin-right: 0; padding: 9px 18px; }

  .ryc-links {
    order: 0;
    flex: 0 0 auto;
    padding: 0;
    background: transparent;
    overflow: visible;
    gap: 12px;
  }
  .ryc-contact-mobile { display: none; }

  .ryc-contact-desktop {
    display: inline-flex;
    align-items: center;
    gap: 6px;
    margin-left: auto;
  }
}
`;

export default Navbar;
